import styled from 'styled-components'
import styles from '../../utility/styles'
import Text from '../shared/Text'
import StoreButton from '../shared/StoreButton'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
    margin-bottom: 48px;
`

const Row = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

export default function Footer() {
	return (
		<Wrapper>
			<Text.Heading type='h5' variant='bold' style={{ marginBottom: '24px' }}>
				Download TezLab Today!
			</Text.Heading>
			<Row>
				<StoreButton style={{ margin: '0 8px', width: '135px', maxWidth: '135px' }} />
				<StoreButton type='android' style={{ margin: '0 8px', width: '135px', maxWidth: '135px' }} />
			</Row>
		</Wrapper>
	)
}
